<template>
    <div class="px-6 py-4 bg-minplan-beige">
        <page-title :title="$t('offers.replace')"></page-title>
    </div>

    <jet-form-section @submitted="replaceOffer()">
        <template #form>
            <!-- Card Offer-->
            <form-card
                :title="$t('topics.offer')"
                :description="$t('topics.offerDescription')"
            >
                <div class="col-span-6">
                    <label for="title" class="block text-sm font-medium text-gray-700">{{
                        $t("offers.title")
                    }} <RequiredMark /></label>
                    <input
                        type="text"
                        name="title"
                        id="title"
                        v-model="form.title"
                        :placeholder="$t('offers.title')"
                        class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                        autofocus
                    />
                    <jet-input-error :message="form.errors.title" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="number" class="block text-sm font-medium text-gray-700">{{
                        $t("offers.number")
                    }}</label>
                    <input
                        type="text"
                        name="number"
                        id="number"
                        v-model="form.number"
                        :placeholder="$t('offers.number')"
                        class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                    />
                    <jet-input-error :message="form.errors.number" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label class="block text-sm font-medium text-gray-700">{{ $t("offers.type.label") }}</label>
                    <div class="mt-1 flex items-center space-x-4">
                        <label class="inline-flex items-center">
                            <input type="radio" :value="false" v-model="form.is_credit" />
                            <span class="ml-2">{{ $t("offers.type.offer") }}</span>
                        </label>
                        <label class="inline-flex items-center ml-4">
                            <input type="radio" :value="true" v-model="form.is_credit" />
                            <span class="ml-2">{{ $t("offers.type.credit") }}</span>
                        </label>
                    </div>
                    <p v-if="form.is_credit" class="mt-1 text-xs text-red-500">{{ $t("offers.type.creditHint") }}</p>
                </div>

                <!-- K-3 (UI-Gate Welle 2, welle2-ui-report.md): die beiden
                     Fee-Checkboxen standen unmittelbar unter der Radiogruppe
                     "Art" ohne eigene Feldbeschriftung und wirkten dadurch wie
                     deren Teil. Das Fieldset gibt ihnen eine gemeinsame
                     Gruppenbeschriftung. -->
                <!-- Entscheid 10 (Auftrag 2026-08-16): Im Budget-Modus gibt es die
                     Fee-Fahnen je Offerte fachlich nicht — sie gehen dort
                     weder in die Rechnung noch als Bedienelement ein.
                     AUSGEBLENDET, nicht gesperrt. Die gespeicherten Werte
                     bleiben unangetastet (Entscheid 3) und reisen im
                     Formular unveraendert mit. -->
                <fieldset v-if="!isBudgetBased" class="col-span-6 border border-gray-200 rounded-md p-3">
                    <legend class="px-1 text-sm font-medium text-gray-700">
                        {{ $t("offers.feeFlagsLabel") }}
                    </legend>
                    <div class="col-span-6">
                        <label
                            class="flex items-center space-x-2 text-sm font-medium text-gray-700"
                            for="applyBaseFee"
                        >
                            <input
                                id="applyBaseFee"
                                name="applyBaseFee"
                                v-model="form.applyBaseFee"
                                type="checkbox"
                                class="border-gray-300 rounded"
                            />
                            <span>{{ $t("offers.applyBaseFee") }}</span>
                        </label>
                        <jet-input-error
                            :message="form.errors.applyBaseFee"
                            class="mt-2"
                        />
                    </div>

                    <div class="col-span-6 mt-3">
                        <label
                            class="flex items-center space-x-2 text-sm font-medium text-gray-700"
                            for="applyConsultancyFee"
                        >
                            <input
                                id="applyConsultancyFee"
                                name="applyConsultancyFee"
                                v-model="form.applyConsultancyFee"
                                type="checkbox"
                                class="border-gray-300 rounded"
                            />
                            <span>{{ $t("offers.applyConsultancyFee") }}</span>
                        </label>
                        <jet-input-error
                            :message="form.errors.applyConsultancyFee"
                            class="mt-2"
                        />
                    </div>
                </fieldset>

                <div class="col-span-6">
                    <label
                        for="costExcl"
                        class="block text-sm font-medium text-gray-700"
                        >{{ $t("offers.cost") }} <RequiredMark /></label
                    >
                    <div class="flex">
                        <span
                            class="inline-flex items-center px-3 border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm mt-1"
                            >CHF</span
                        >
                        <input
                            type="number"
                            step="0.01"
                            name="costExcl"
                            id="costExcl"
                            v-model="form.costExcl"
                            :placeholder="$t('offers.cost')"
                            class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                        />
                    </div>
                    <jet-input-error :message="form.errors.costExcl" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label
                        for="taxRate"
                        class="block text-sm font-medium text-gray-700"
                        >{{ $t("offers.taxRate") }}</label
                    >
                    <div class="mt-1 flex">
                        <Dropdown
                            id="taxRate"
                            v-model="form.vatCode"
                            :options="taxRates"
                            optionValue="code"
                            optionLabel="name"
                            :placeholder="$t('offers.taxRate')"
                            :showClear="true"
                            class="w-full"
                        />
                    </div>
                    <jet-input-error :message="form.errors.vatCode" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label class="block text-sm font-medium text-gray-700">
                        {{ $t("offers.file") }} <RequiredMark v-if="$page.props.isOfferDocumentRequired" />
                    </label>
                    <FileDropzone :accept="fileAccept" @file="onDropFile" @reject="onFileRejected">
                        <div class="mt-1 flex items-center">
                            <div class="mt-2 w-full" v-show="fileUploaded">
                                <span class="block">{{ fileUploaded }}</span>
                            </div>

                            <jet-secondary-button
                                class="mt-2 mr-2"
                                type="button"
                                @click.prevent="selectNewFile"
                                v-if="!fileUploaded"
                                >{{ $t("actions.chooseFile") }}
                            </jet-secondary-button>
                            <jet-secondary-button
                                class="mt-2 mr-2"
                                type="button"
                                @click.prevent="clearFileInput"
                                v-if="fileUploaded"
                                >{{ $t("actions.removeFile") }}
                            </jet-secondary-button>

                            <input
                                type="file"
                                class="hidden"
                                ref="file"
                                :accept="fileAccept"
                                @change="updateFileUploaded"
                            />
                        </div>
                    </FileDropzone>
                    <p class="my-3 text-sm text-gray-400">
                        <!-- Der engere Hinweis erscheint nur, wenn die
                             Signaturfrage auch wirklich gestellt ist: auf einem
                             frisch geoeffneten Modal steht `digital_signature`
                             bereits auf "Yes", die Frage aber erst nach der Wahl
                             einer PDF — vorher haette der Hinweis 10 MB genannt,
                             obwohl fuer eine ZIP-Datei 20 MB gelten. -->
                        <span v-if="signatureLimitApplies">{{ $t("offers.fileInfoSigned", { size: maxSizeInMb }) }}</span>
                        <span v-else>{{ $t("offers.fileInfo", { size: maxSizeInMb }) }}</span>
                    </p>
                    <jet-input-error :message="form.errors.file" class="mt-2" />
                </div>

                <div class="col-span-6" v-if="$page.props.offer_document_digital_sign_mode === 'On' && isPdfSelected">
                    <label class="block text-sm font-medium text-gray-700">{{ $t("offers.digitalSignatureRequired") }}</label>
                    <div class="mt-1 flex items-center space-x-4">
                        <label class="inline-flex items-center"><input type="radio" value="Yes" v-model="form.digital_signature" /> <span class="ml-2">{{ $t("actions.yes") }}</span></label>
                        <label class="inline-flex items-center ml-4"><input type="radio" value="No" v-model="form.digital_signature" /> <span class="ml-2">{{ $t("actions.no") }}</span></label>
                    </div>
                </div>

                <div class="col-span-6">
                    <label for="bkps" class="block text-sm font-medium text-gray-700">{{
                        $t("offers.bkps")
                    }}</label>
                    <div class="mt-1 flex">
                        <Dropdown
                            filter
                            id="bkps"
                            v-model="form.bkp"
                            :options="enrichedBkps"
                            optionValue="value"
                            optionLabel="name"
                            :placeholder="$t('offers.bkp.none')"
                            :showClear="true"
                            class="w-full"
                            @change="handleBkpChange"
                        />
                    </div>
                    <jet-input-error :message="form.errors.bkp" class="mt-2" />
                </div>

                <div class="col-span-6" v-if="form.bkp === 'other'">
                    <label
                        for="customBkp"
                        class="block text-sm font-medium text-gray-700"
                        >{{ $t("offers.customBkp") }}</label
                    >
                    <input
                        type="text"
                        name="title"
                        id="title"
                        v-model="form.customBkp"
                        :placeholder="$t('offers.customBkp')"
                        class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                        autofocus
                    />
                    <jet-input-error :message="form.errors.customBkp" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label
                        for="suppliers"
                        class="block text-sm font-medium text-gray-700"
                        >{{ $t("topics.supplier") }}</label
                    >
                    <div class="mt-1 flex">
                        <Dropdown
                            filter
                            id="suppliers"
                            v-model="form.supplier"
                            :options="alleUnternehmer"
                            optionValue="uuid"
                            optionLabel="name"
                            :placeholder="$t('suppliers.noSupplier')"
                            :showClear="true"
                            class="w-full"
                        />
                    </div>
                    <jet-input-error :message="form.errors.supplier" class="mt-2" />
                    <!-- Unternehmer direkt hier anlegen (Entscheid Peter,
                         31.08.2026) — gleiche Stelle wie in der Themen-Maske. -->
                    <SupplierCreateInline @created="uebernehmeNeuenUnternehmer" />
                </div>

                <!-- R3 Punkt 4: `v-show` statt `v-if` — s. Docblock
                     `ContactPicker.vue` (Reset-Watcher braucht dauerhaftes
                     Mounten). -->
                <div class="col-span-6" v-show="selectedSupplier">
                    <label class="block text-sm font-medium text-gray-700">{{
                        $t("suppliers.contactPerson")
                    }}</label>
                    <ContactPicker
                        :supplier="selectedSupplier"
                        :value="form.supplierContact"
                        @input="form.supplierContact = $event"
                    />
                    <jet-input-error :message="form.errors.supplierContact" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label
                        for="comment"
                        class="block text-sm font-medium text-gray-700"
                        >{{ $t("offers.comment") }}</label
                    >
                    <div class="flex">
                        <textarea
                            type="textarea"
                            name="comment"
                            id="comment"
                            v-model="form.comment"
                            :placeholder="$t('offers.comment')"
                            class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                        />
                    </div>
                    <jet-input-error :message="form.errors.comment" class="mt-2" />
                </div>
            </form-card>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">
                <button
                    @click="cancel"
                    type="button"
                    class="inline-block uppercase font-semibold text-xs tracking-widest"
                >
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button
                    type="button"
                    @click="handleSave"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    class="ml-3"
                >
                    <span v-if="form.processing" class="flex items-center gap-1">
                        <svg class="animate-spin h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                        Saving...
                    </span>
                    <span v-else>{{ $t("actions.save") }}</span>
                </primary-button>
            </div>
        </template>
    </jet-form-section>

    <teleport to="body">
        <digital-signature-config 
            v-if="showSignConfigModal"
            class="digital-signature-config-modal-root"
            :buyers="buyers"
            :pdf-base64="pdfBase64"
            :file-name="form.title || fileUploaded"
            :auth-user-id="auth_user_id"
            :max-buyer-select="$page.props.offer_document_digital_sign_max_buyer_select"
            @cancel="showSignConfigModal = false"
            @done="finalizeDigitalSignature"
        />
    </teleport>
</template>

<script>
import { defineComponent, ref } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm, usePage } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import { useI18n } from "vue-i18n";
import RequiredMark from "@/Shared/Components/RequiredMark";
import DigitalSignatureConfig from "@/Shared/Components/Documents/Modals/DigitalSignatureConfig.vue";
import FileDropzone from "@/Shared/Components/FileDropzone.vue";
import ContactPicker from "@/Shared/Components/Suppliers/ContactPicker.vue";
import SupplierCreateInline from "@/Shared/Components/Suppliers/SupplierCreateInline.vue";

// Fix Welle 4.5 UI-Gate, Nachprüfung f6c76cbb: s. Docblock/Kommentar bei
// `fileAccept` in `CreateOffer.vue`.
const OFFER_FILE_ACCEPT =
    ".pdf,.zip,application/pdf,application/zip,application/x-zip-compressed";

export default defineComponent({
    props: ["suppliers", "replaceLink", "offer", "bkps", "taxRates", "buyers", "auth_user_id", "max_signed_offer_upload_size", "feeCalculation"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        RequiredMark,
        DigitalSignatureConfig,
        FileDropzone,
        ContactPicker,
        SupplierCreateInline,
    },
    computed: {
        // Entscheid 10 (Auftrag 2026-08-16): fehlt die Prop, bleibt die Maske
        // wie bisher — Offerten-Modus ist der Default.
        isBudgetBased() {
            return this.feeCalculation ? this.feeCalculation.isBudgetBased : false;
        },
        // Befund H-6: statt die Inertia-Prop `suppliers` per `push()` zu
        // mutieren, fuehrt eine lokale Liste die frisch angelegten
        // Unternehmer — `alleUnternehmer` fuehrt beides zusammen.
        alleUnternehmer() {
            return [...(this.suppliers || []), ...this.zusaetzlicheUnternehmer];
        },
        selectedSupplier() {
            return this.alleUnternehmer.find((supplier) => supplier.uuid === this.form.supplier) ?? null;
        },
        // Zu signierende Offerten unterliegen einer engeren Grenze
        // (`core.max_signed_offer_upload_size`, als Seiten-Prop geliefert) —
        // ohne Signatur bleibt `max_offer_upload_size` massgeblich. Dieselbe
        // Weiche steht serverseitig in StoreOfferRequest/UpdateOfferRequest;
        // hier ist sie nur die frueher greifende Rueckmeldung, nicht der
        // Schutz.
        // Die engere Grenze gilt nur, wenn die Signaturfrage im Formular
        // ueberhaupt gestellt ist (Modus aktiv UND eine PDF gewaehlt) und mit
        // "Ja" beantwortet wurde.
        signatureLimitApplies() {
            return (
                this.$page.props.offer_document_digital_sign_mode === "On" &&
                this.isPdfSelected &&
                this.form.digital_signature === "Yes"
            );
        },
        maxBytesForSelection() {
            const unsigned =
                this.$page.props.branding?.max_offer_upload_size || 20 * 1024 * 1024;
            // `max_signed_offer_upload_size` ist ein SEITEN-Prop der
            // Modal-Route und kommt ueber `v-bind` in `ComponentModal` als
            // Komponenten-Prop an — NICHT ueber `$page.props`, das hier die
            // Gastgeberseite ist.
            const signed = this.max_signed_offer_upload_size || 10 * 1024 * 1024;
            return this.signatureLimitApplies ? signed : unsigned;
        },
        maxSizeInMb() {
            return Math.round(this.maxBytesForSelection / 1024 / 1024);
        },
        // R3 Punkt 7 / Fix Welle 4.5 UI-Gate (Nachprüfung f6c76cbb): s.
        // Docblock/Kommentar bei `fileAccept` in `CreateOffer.vue` — jetzt
        // IMMER dieselbe Offerten-Whitelist, unabhängig von
        // `form.digital_signature`.
        fileAccept() {
            return OFFER_FILE_ACCEPT;
        },
        isPdfSelected() {
            if (!this.fileUploaded) return false;
            return this.fileUploaded.toLowerCase().endsWith('.pdf');
        }
    },
    watch: {
        // Fix Welle 4.5 UI-Gate (welle45-ui-report.md, blockierender Befund):
        // ein reiner Wertwechsel-Watcher auf `isPdfSelected` feuert nicht,
        // wenn direkt (ohne vorherige PDF-Auswahl) eine Nicht-PDF-Datei
        // gewählt wird. Der Reset passiert deshalb jetzt deterministisch in
        // `updateFileUploaded()` bei jeder Dateiauswahl — s. Kommentar dort.
        // R3 Punkt 4: der Unternehmer-Wechsel-Reset der Kontaktperson wandert
        // in `ContactPicker.vue` (PoC-Fehler 2, Backend-Pendant
        // `Offer::replace():174-178` bleibt unverändert) — kein eigener
        // Watcher mehr hier.
    },
    methods: {
        /**
         * Der frisch angelegte Unternehmer wandert in die Auswahlliste und ist
         * gleich gewählt — ohne Neuladen, damit die bereits erfassten Angaben
         * dieser Offerte erhalten bleiben.
         */
        uebernehmeNeuenUnternehmer(supplier) {
            this.zusaetzlicheUnternehmer.push(supplier);
            this.form.supplier = supplier.uuid;
            this.form.supplier_contact_uuid = null;
        },
        cancel() {
            this.$emit("closeModal");
        },
        handleSave() {
            if (!this.form.title) {
                this.form.errors.title = "Title is required.";
                return;
            }

            if (this.$refs.file && this.$refs.file.files[0]) {
                const fsize = this.$refs.file.files[0].size;
                const maxBytes = this.maxBytesForSelection;

                if (fsize > maxBytes) {
                    this.$notify({
                        group: "error",
                        title: "actions.error",
                        // Der Toast kuerzt bei 100 Zeichen und laeuft auf
                        // einem Timer ab — die Meldung nennt darum knapp die
                        // Grenze, statt in einem abgeschnittenen Satz zu
                        // enden.
                        text: this.signatureLimitApplies
                            ? this.$t("offers.signedFileTooBig", {
                                  size: this.maxSizeInMb,
                              })
                            : "offers.fileTooBig",
                    });
                    return;
                }

                const fileExt = this.$refs.file.files[0].name.split('.').pop().toLowerCase();
                
                if (this.form.digital_signature === 'Yes' && fileExt !== 'pdf') {
                    this.$notify({ group: "error", title: "actions.error", text: "offers.digitalSignatureRequiresPdf" });
                    return;
                }

                this.form.file = this.$refs.file.files[0];

                if (this.form.digital_signature === 'Yes') {
                    this.loadPdfBase64();
                    this.showSignConfigModal = true;
                    return;
                }
            } else if (this.form.digital_signature === 'Yes') {
                this.form.digital_signature = 'No';
            }

            this.replaceOffer();
        },
        replaceOffer() {
            this.form.file = this.$refs.file.files[0];

            this.form.post(this.replaceLink, {
                preserveScroll: true,
                onSuccess: () =>
                    this.$notify({
                        group: "success",
                        title: "actions.success",
                        text: "offers.replaced",
                    }),
            });
        },
        loadPdfBase64() {
            const file = this.$refs.file.files[0];
            const reader = new FileReader();
            reader.onload = () => {
                const dataUrl = reader.result;
                if (typeof dataUrl === 'string') {
                    this.pdfBase64 = dataUrl.split(',')[1];
                    this.pdfLoaded = true;
                }
            };
            reader.readAsDataURL(file);
        },
        b64toFile(b64Data, contentType='', sliceSize=512) {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) byteNumbers[i] = slice.charCodeAt(i);
                byteArrays.push(new Uint8Array(byteNumbers));
            }
            return new File(byteArrays, this.form.title + ".pdf", { type: contentType });
        },
        finalizeDigitalSignature(payload) {
            this.showSignConfigModal = false;
            this.form.digital_sign_json = payload.digital_sign_json;
            if (payload.pdf_base64_signed) {
                this.form.file = this.b64toFile(payload.pdf_base64_signed, 'application/pdf');
            }
            this.replaceOffer();
        },
        selectNewFile() {
            this.$refs.file.click();
        },
        clearFileInput() {
            if (this.$refs.file?.value) {
                this.$refs.file.value = null;
                this.fileUploaded = null;
            }
        },
        updateFileUploaded() {
            const file = this.$refs.file.files[0];

            if (!file) return;

            this.fileUploaded = file.name;

            // Fix Welle 4.5 UI-Gate: bei jeder (auch der ersten) Auswahl
            // einer Nicht-PDF-Datei deterministisch auf "No" zurücksetzen —
            // s. Kommentar beim `watch`-Block oben.
            if (!file.name.toLowerCase().endsWith('.pdf')) {
                this.form.digital_signature = 'No';
            }
        },
        onDropFile(file) {
            const dt = new DataTransfer();
            dt.items.add(file);
            this.$refs.file.files = dt.files;
            this.$refs.file.dispatchEvent(new Event("change", { bubbles: true }));
        },
        // W2 (Fix-Runde 1): s. Kommentar in `CreateOffer.vue`.
        onFileRejected() {
            this.$notify({
                group: "error",
                title: "actions.error",
                text: "offers.fileTypeInvalid",
            });
        },
        handleBkpChange() {
            if (this.form.bkp !== "other") {
                this.form.customBkp = null;
            }
        },
    },
    setup(props) {
        const fileUploaded = ref(null);
        const { t } = useI18n();
        const { props: pageProps } = usePage();
        const dsMode = pageProps.value.offer_document_digital_sign_mode;

        const form = useForm({
            title: props.offer.title,
            costExcl: null,
            number: null,
            comment: props.offer.comment,
            file: null,
            supplier: props.offer.supplier_uuid,
            // Thema 9 Paket c (PoC-Fehler 2): Prefill aus der ERSETZTEN
            // Offerte, analog zum Unternehmer eine Zeile darüber — das
            // Backend (`Offer::replace():174-178`) erbt den Kontakt zwar
            // auch ohne DTO-Wert, solange der Unternehmer gleich bleibt,
            // aber nur eine sichtbare Vorbelegung macht den Bezug im Modal
            // nachvollziehbar und übersteht einen Supplier-Wechsel-zurück.
            supplierContact: props.offer.supplier_contact_uuid ?? null,
            vatCode: props.offer.vatCode,
            bkp: props.offer.bkp,
            customBkp: props.offer.customBkp,
            digital_signature: dsMode === 'Off' ? "No" : "Yes",
            digital_sign_json: null,
            is_credit: props.offer.is_credit,
            applyBaseFee: props.offer.apply_base_fee ?? true,
            applyConsultancyFee: props.offer.apply_consultancy_fee ?? true,
        });

        const enrichedBkps = [
            ...props.bkps.map((bkp) => ({
                value: bkp,
                name: t(`offers.bkp.N${bkp.replace(".", "_")}`),
            })),
            { value: "other", name: t("offers.bkp.other") },
        ];

        return { form, fileUploaded, enrichedBkps };
    },
    data() {
        return {
            showSignConfigModal: false,
            pdfLoaded: false,
            pdfBase64: null,
            // Befund H-6: frisch angelegte Unternehmer landen hier statt in
            // der Prop `suppliers` (s. `alleUnternehmer`/`uebernehmeNeuenUnternehmer`).
            zusaetzlicheUnternehmer: [],
        }
    }
});
</script>

<style scoped></style>
